/**
* BugNoteAnnotationEntity Interface
*
* Generated file, don't touch manually
*
* ModelVersion: 90001
*/

export { BugNoteAnnotationEntity } from "@archipad-js/archipad-model";
